export default "__VITE_ASSET__9ZIC1NUk__"